const Routes = Object.freeze({
  DASHBOARD: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  ONBOARDING: '/onboarding',
  BUSINESS_ONBOARDING: '/business-onboarding',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',
  CARERS: '/carers',
  CARER_DETAILS: '/carers/:carerId',
  MESSAGES: '/messages',
  MESSAGES_WITH_USER: '/messages/:userId',
  BOOKING: '/booking',
  BOOKING_DETAILS: '/booking/:bookingId',
  INTRO_CALLS: '/intro-calls',
  INTRO_CALL_DETAILS: '/intro-calls/:introCallId',
  DOCUMENTS: '/documents',
  FAQ: '/faq',
  SETTINGS: '/settings',
  PAYMENT_SELECT: '/payment-select',
  DATA_TABLE: '/data-table',
  INPUTS: '/inputs',
  SANDBOX: '/sandbox',
  EMAIL_TEMPLATE: '/email-template',
  PASSWORD_CHANGED_CONFIRMATION: '/password-changed',
  EMAIL_CHANGED_CONFIRMATION: '/email-changed',
  TERMS: '/terms',
  PRIVACY_POLICY: '/privacy-policy',
  // Admin routes
  ADMIN_FAMILIES: '/admin/families',
  ADMIN_FAMILY_DETAILS: '/admin/families/:familyId',
  ADMIN_CARERS: '/admin/carers',
  ADMIN_CARER_DETAILS: '/admin/carers/:carerId',
  ADMIN_REQUESTS: '/admin/requests',
  ADMIN_BOOKINGS: '/admin/bookings',
} as const);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
